class CartDrawerRecommendations {
  constructor() {
    this.container = document.querySelector('[data-cart-recommendations]');
    if (!this.container) return;

    this.limit = this.container.dataset.limit || 4;
    this.init();
  }

  async init() {
    const cart = await this.getCart();
    if (!cart.items.length) return;

    // Use LAST added item (best UX)
    const productId = cart.items[cart.items.length - 1].product_id;
    this.loadRecommendations(productId);
  }

  async getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  loadRecommendations(productId) {
    fetch(`/recommendations/products.json?product_id=${productId}&limit=${this.limit}`)
      .then(res => res.json())
      .then(data => {
        if (!data.products.length) return;
        this.renderProducts(data.products);
      });
  }

  renderProducts(products) {
    const html = products.map(product => `
      <div class="cart-reco-item">
        <a href="${product.url}">
          <img src="${product.featured_image}" alt="${product.title}">
          <p>${product.title}</p>
          <span>${Shopify.formatMoney(product.price)}</span>
        </a>

        <button
          type="button"
          class="cart-reco-add"
          data-variant-id="${product.variants[0].id}">
          Add to cart
        </button>
      </div>
    `).join('');

    this.container.querySelector(
      '.cart-drawer-recommendations__products'
    ).innerHTML = html;

    this.bindAddToCart();
  }

  bindAddToCart() {
    this.container.querySelectorAll('.cart-reco-add').forEach(button => {
        button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // IMPORTANT
        this.addToCart(button.dataset.variantId);
        });
    });
  }

  addToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
        id: variantId,
        quantity: 1
        })
    })
    .then(() => {
        // Trigger theme cart refresh
        document.dispatchEvent(
        new CustomEvent('cart:build', { bubbles: true })
        );

        // Re-init recommendations
        new CartDrawerRecommendations();
    });
  }
}

/* Init */
document.addEventListener('DOMContentLoaded', () => {
  new CartDrawerRecommendations();
});

/* Re-init after cart changes */
document.addEventListener('cart:refresh', () => {
  new CartDrawerRecommendations();
});

/* Re-init after cart updated */
document.addEventListener('cart:updated', () => {
  new CartDrawerRecommendations();
});